import { Component } from "react";
import { connect } from "react-redux";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { AppState } from "../../../../app/store/rootReducers";
import { AiOutlineHeart } from "react-icons/ai";
import Config from "../../../../config/config";
import Segments from "../../../../constants/Segments";
import PageUrls from "../../../../constants/PageUrls";
import {
  getActiveLanguage,
  getLabelsByLanguage,
} from "../../../../utilites/util";
import history from "../../../../utilites/history";
import RedirectToYettelAccountPopup from "../../redirectToTnAccountPopup";
import "./scss/WishListIconContainer.scss";

type WishListIconContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

type WishListIconContainerState = {
  isRedirectionPopupOpen: boolean
};

export class WishListIconContainer extends Component<WishListIconContainerProps, WishListIconContainerState> {

  constructor(props: WishListIconContainerProps) {
    super(props);

    this.state = {
      isRedirectionPopupOpen: false,
    };
  }

  setIsRedirectionPopupOpen(value: boolean) {
    this.setState({ isRedirectionPopupOpen: value });
  }

  handleOnClick() {
    const lang = getActiveLanguage();

    if (!this.props.session.user.isLoggedIn) {
      this.setIsRedirectionPopupOpen(true);
      return;
    }

    return history.push(
      `${Config.prefixUrl}/${lang}/${Segments[lang].PRIVATE_SEGMENT}/${PageUrls[lang].WISH_LIST}`
    );
  }

  render() {
    const { wishListProductNum } = this.props;
    const labels = getLabelsByLanguage();

    return (
      <span className="wish-list-icon position-relative icon mx-auto d-block pt-1">
        <span onClick={this.handleOnClick.bind(this)} data-testid="toggle-popup">
          <AiOutlineHeart
            className="wish-list-heart position-absolute"
            size={"1.9em"}
          />
          {wishListProductNum ? (
            <div data-testid="wishilst-counter" className="wish-list-counter position-absolute">
              <span>{wishListProductNum}</span>
            </div>
          ) : null}
        </span>
        {this.state.isRedirectionPopupOpen && (
          <RedirectToYettelAccountPopup
            primaryLabel={labels.redirectionToLoginMessage}
            secondaryLabel={labels.redirectionToLoginExplainedMessage}
          />
        )}
      </span>
    );
  }

}

const mapStateToProps = (state: AppState) => {
  return {
    wishListProductNum: Array.isArray(state.wishList.productIds) ? state.wishList.productIds.length : 0,
    session: state.session,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WishListIconContainer);
